import React, { useState } from "react";
import { useDrag } from "react-dnd";

export default function ListItem({
  Sheetid,
  SheetName,
  droppableWidth,
  isParagraph,
  SheetVizType,
  dataSourceID,
}) {
  // console.log(SheetVizType);

  const height = 4;
  const width = 8;

  const [{ isDragging }, drag] = useDrag({
    type: "ITEM",
    item: {
      Sheetid,
      SheetName,
      width,
      height,
      isParagraph,
      SheetVizType,
      dataSourceID,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      ref={drag}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`${
        isDragging ? "bg-opacity-50" : ""
      } w-[${width}px] h-[${height}px] cursor-move font-light text-[14px] truncate relative`}
    >
      {SheetName}
      {isHovered && (
        <i className="absolute top-0 right-0 text-center text-xs z-10 bg-black text-white p-[2px] rounded">
          {SheetName}
        </i>
      )}
    </div>
  );
}
